import arrowToggle from './by-type/arrowToggle';
import checkbox from './by-type/checkbox';
import checkboxGroup from "./by-type/checkboxGroup";
import date from './by-type/date';
import dateToDate from './by-type/dateToDate';
import leftRightSelect from './by-type/leftRightSelect';
import ajaxLeftRightSelect from "./by-type/ajaxLeftRightSelect";
import leftRightGroupableSelect from './by-type/leftRightGroupableSelect';
import singleSelect from './by-type/singleSelect';
import multiSelect from './by-type/multiSelect';
import singleSearchableSelect from './by-type/singleSearchableSelect';
import multiSearchableSelect from './by-type/multiSearchableSelect';
import singleAjaxSelect from './by-type/singleAjaxSelect';
import multiAjaxSelect from './by-type/multiAjaxSelect';
import number from './by-type/number';
import pillbox, {checkPillboxTagError} from './by-type/pillbox';
import radioGroup from './by-type/radioGroup';
import text from './by-type/text';
import time from './by-type/time';
import timeToTime from './by-type/timeToTime';
import getRuleValue from "./utils/getRuleValue";
import CustomFormExtendable from "../CustomFormExtendable";

export default function checkError(type, value, rules, options, allValues) {

    switch (type) {
        case 'text': return text(value, rules, options, allValues);
        case 'number': return number(value, rules, options, allValues);
        case 'checkbox': return checkbox(value, rules, options, allValues);
        case 'checkboxGroup': return checkboxGroup(value, rules, options, allValues);
        case 'arrowToggle': return arrowToggle(value, rules, options, allValues);
        case 'singleSelect': return singleSelect(value, rules, options, allValues);
        case 'multiSelect': return multiSelect(value, rules, options, allValues);
        case 'singleSearchableSelect': return singleSearchableSelect(value, rules, options, allValues);
        case 'multiSearchableSelect': return multiSearchableSelect(value, rules, options, allValues);
        case 'singleAjaxSelect': return singleAjaxSelect(value, rules, options, allValues);
        case 'multiAjaxSelect': return multiAjaxSelect(value, rules, options, allValues);
        case 'leftRightSelect': return leftRightSelect(value, rules, options, allValues);
        case 'ajaxLeftRightSelect': return ajaxLeftRightSelect(value, rules, options, allValues);
        case 'leftRightGroupableSelect': return leftRightGroupableSelect(value, rules, options, allValues);
        case 'radioGroup': return radioGroup(value, rules, options, allValues);
        case 'pillbox': return pillbox(value, rules, options, allValues);
        case 'date': return date(value, rules, options, allValues);
        case 'dateToDate': return dateToDate(value, rules, options, allValues);
        case 'time': return time(value, rules, options, allValues);
        case 'timeToTime': return timeToTime(value, rules, options, allValues);
    }

    return CustomFormExtendable.checkError(type, value, rules, options, allValues);
}

function checkIsRequired(type, rules, allValues) {
    let ruleValue = getRuleValue(rules.required, allValues);

    if (ruleValue instanceof Array) {
        switch (type) {
            case 'dateToDate':
            case 'timeToTime':
                return ruleValue[0] || ruleValue[1];
        }
    }

    ruleValue = CustomFormExtendable.parseRequiredRuleValue(ruleValue);

    if ('boolean' === typeof ruleValue) {
        return ruleValue;
    }

    console.error(`Type of ruleValue must be boolean:`, ruleValue);
    return false;
}

export {
    checkIsRequired,
    getRuleValue,
    checkPillboxTagError
}
